/**
 * useCurrentUser — provides the authenticated tracker_user to the component tree.
 *
 * Wraps children inside AuthGate (after linking is resolved).
 * Exposes the linked tracker_user object so components don't need to
 * infer the current user from activeView.
 */

import React, { createContext, useContext, useMemo } from 'react';

const CurrentUserContext = createContext(null);

export function CurrentUserProvider({ user, children }) {
    const value = useMemo(() => user, [user?.id]);
    return (
        <CurrentUserContext.Provider value={value}>
            {children}
        </CurrentUserContext.Provider>
    );
}

export function useCurrentUser() {
    return useContext(CurrentUserContext);
}

export default useCurrentUser;
